import React from "react";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";

import { Props } from "./types";
import styles from "./styles.scss";

function DetailsPopup({
  canShowPopup,
  element,
  startDate,
  endDate,
  isLeft,
  isRight,
  children,
}: Props) {
  const { t } = useTranslation();
  // startDate / endDate are JS Date instances synthesized by the
  // drag/resize handlers (Phase 3). Format only; upstream construction
  // is unchanged in this phase.
  const startLabel = DateTime.fromJSDate(startDate).toLocaleString(
    DateTime.DATE_SHORT,
  );
  const endLabel = DateTime.fromJSDate(endDate).toLocaleString(
    DateTime.DATE_SHORT,
  );

  return (
    <div className={styles.resizePopup}>
      {children}
      {canShowPopup && (
        <div
          className={styles.popup}
          style={{
            left: isLeft ? 0 : undefined,
            right: isRight ? 0 : undefined,
          }}
        >
          <p className={styles.name}>{element.name}</p>
          <p className={styles.text}>
            <span className={styles.label}>
              {t("gantt.resizePopup.startDate")}:
            </span>{" "}
            {startLabel}
          </p>
          <p className={styles.text}>
            <span className={styles.label}>
              {t("gantt.resizePopup.endDate")}:
            </span>{" "}
            {endLabel}
          </p>
        </div>
      )}
    </div>
  );
}

export { DetailsPopup };
